import { definePage } from '@reflex/plugin-api/web';
import type { PluginWebManifest } from '@reflex/plugin-api/web';

const page = definePage({
  path: '/leaderboard',
  label: 'Leaderboard',
  icon: 'Trophy',
  group: 'misc',
  componentPath: '@reflex/plugin-leaderboard/web/LeaderboardPage',
  description: 'See who is shipping the most PRs.',
  details: 'Tracks merged pull requests across all configured GitHub repos.',
  features: ['PR merge tracking', 'Author rankings', 'Top repo per author'],
});

export const leaderboardWeb: PluginWebManifest = {
  ...page.web,
  marketingPreviews: [
    {
      id: 'leaderboard-page',
      label: 'Leaderboard page',
      description: 'Top, mid, and bottom contributors with sample PR counts.',
      surface: 'page',
      componentPath: '@reflex/plugin-leaderboard/web/LeaderboardPagePreview',
    },
  ],
};
